import { css } from 'linaria';

export const cardImageSwiper = css`
  && {
    &.swiper {
      padding: 0;
      margin: auto;
    }

    & .swiper-button-next.swiper-button-next {
      right: 8px;
      display: none;
      width: 32px;
      height: 32px;
      border: none;
    }

    & .swiper-button-prev.swiper-button-prev {
      left: 8px;
      display: none;
      width: 32px;
      height: 32px;
      border: none;
    }

    & .swiper-button-next.swiper-button-next:hover,
    & .swiper-button-prev.swiper-button-prev:hover {
      background-color: var(--control-hover-primary-invert);
      border: none;
    }

    &:hover .swiper-button-next.swiper-button-next,
    &:hover .swiper-button-prev.swiper-button-prev {
      display: flex;

      @media (--to-tablet) {
        display: none;
      }
    }

    & .swiper-pagination.swiper-pagination {
      left: 50%;
      display: flex;
      width: max-content;
      padding: 4px;
      column-gap: 4px;
      background-color: rgba(255, 255, 255, 0.4);
      border-radius: 100px;
      transform: translateX(-50%);

      & .swiper-pagination-bullet {
        margin: 0;
        background-color: var(--control-invert);
        opacity: 1;
      }

      & .swiper-pagination-bullet-active {
        background-color: var(--control-primary);
      }
    }
  }
`;

export const cardImage = css`
  display: block;
  width: 100%;
  height: 236px;
  border-radius: var(--rounding-l) var(--rounding-l) 0 0;
  object-fit: cover;

  @media (--only-tablet) {
    height: 184px;
  }
`;

export const priceCardName = css`
  && {
    margin-bottom: 4px;
  }
`;

export const priceCardDescription = css`
  && {
    margin-bottom: 14px;
  }
`;
